import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Combina clases condicionales (`clsx`) y resuelve conflictos de utilidades
 * Tailwind en el orden correcto (`tailwind-merge`) — ej. `cn("px-2", cond &&
 * "px-4")` deja `px-4` en vez de mandar ambas al DOM. Patrón estándar en
 * cualquier atomo de este proyecto: `className={cn("base-classes", className)}`.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
